import { IntegrationChannelMetadata } from '@modules/integrationsV2/types';
import {
  getIntegrationChannelsMetadata,
  mapConnectedIntegrationToWorkspaces,
} from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

export const getAllIntegrationChannelsMetadataDetails = (
  integrations: IntegrationViewFragment[],
) => {
  const connectedWorkspaces = mapConnectedIntegrationToWorkspaces(integrations);

  const connectedWorkspacesMap = new Map(
    connectedWorkspaces.map((workspace) => [workspace.id, workspace.name]),
  );

  return integrations.reduce(
    (acc: IntegrationChannelMetadata[], integration) => {
      const channelsMetadata = getIntegrationChannelsMetadata(
        integration.channel.type,
        integration.data,
      );

      const descriptionMap = new Map(
        integration.description?.descriptionMap?.map((description) => [
          description.sourceID,
          description.description,
        ]) ?? [],
      );

      return [
        ...acc,
        ...(channelsMetadata?.map((channelMetadata) => ({
          channelID: channelMetadata.id,
          channelName:
            integration.channel.type === IntegrationChannelType.Slack
              ? `#${channelMetadata.name}`
              : channelMetadata.name,
          channelDescription: descriptionMap.get(channelMetadata.id) ?? '',
          integrationID: integration.id,
          workspaceName: connectedWorkspacesMap.get(integration.id) ?? '',
          integrationChannel: integration.channel,
          integrationType: integration.integrationType,
          allChannelDescriptions: integration.description?.descriptionMap ?? [],
        })) ?? []),
      ];
    },
    [],
  );
};
